import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'

/**
 * used for mobile view of service worker.
 * TODO: describe what this hook is actually doing
 * @param title
 */
const useSelectedUserRoutes = (title: string): void => {
  const dispatch = useDispatch()

  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (title) {
        dispatch(
          appUpdate({
            title,
          })
        )
      }
    }

    return () => {
      mounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title])
}

export default useSelectedUserRoutes
